import Custom from "../../../Components/Buttons/Custom";
import Table from "../../../Components/Table/Table";
import FilterColorful from "../../../Components/Buttons/FilterColorful";
import StatusColorful from "../../../Components/Table/Components/StatusColorful";
import { isoToJalali } from "../../../helper/isoToJalali";
import { useState, useEffect } from "react";
import TableLoading from "../../../Components/Loader/TableLoading";
import SVG from "../../../Components/SVG";

const PAYMENT_TYPE_LABELS = {
  manual: "کیف کریپتو",
  nowpayment: "درگاه کریپتو",
  directpay: "درگاه ریالی",
};

const formatTransactionAmount = (item) => {
  if (item.currency === "IRR") {
    return `${Number(item.amount_irr).toLocaleString()} ریال`;
  }

  return `$${Number(Number(item.amount).toFixed(2)).toLocaleString()}`;
};

export default function TableProfit({ historyData, accLoading }) {
  const [activeFilters, setActiveFilter] = useState([true, true, true]);
  const [filteredData, setFilteredData] = useState([]);

  // 🔥 Whenever historyData changes → map + filter it
  useEffect(() => {
    if (!historyData) return;

    // 1. Map backend data → table rows
    const mapped = historyData.map((item) => {
      const status =
        item.status === "completed"
          ? "done"
          : item.status === "pending"
            ? "stall"
            : "failed";

      return {
        uuid: item.code,
        transactionType:
          item.transaction_type === "payment" ? "deposit" : "withdraw",
        paymentType:
          item.transaction_type === "payment"
            ? PAYMENT_TYPE_LABELS[item.payment_type] || "-"
            : "-",
        requestDate: isoToJalali(item.created_at),
        volume: formatTransactionAmount(item),
        accountID: item.account_code,
        doneDate:
          item.status === "completed" ? isoToJalali(item.updated_at) : "-",
        status, // "done" | "stall" | "failed"
      };
    });

    // 2. Apply filters
    const filtered = mapped.filter((row) => {
      if (row.status === "done") return activeFilters[0];
      if (row.status === "stall") return activeFilters[1];
      if (row.status === "failed") return activeFilters[2];
      return false;
    });

    setFilteredData(filtered);
  }, [historyData, activeFilters]);
  // ⬆️ Re-run when historyData or filters change

  return (
    <div className="w-full p-5 flex flex-col gap-5 rounded-2xl bg-zi-bg2-light dark:bg-zi-bg2-dark">
      {/* FILTERS */}
      <div className="w-full flex gap-2.5 items-center justify-start pt-px pb-2.5 border-b border-b-zi-border-light dark:border-b-zi-border-dark overflow-x-auto">
        <span className="text-xs font-light text-zi-text-light dark:text-zi-text-dark">
          فیلتر:
        </span>

        <FilterColorful
          SVGName="tick"
          text="تکمیل شده"
          className="w-24"
          color={activeFilters[0] ? "green" : "gray"}
          activeFilter={activeFilters}
          setActiveFilter={setActiveFilter}
          filterIndex={0}
        />

        <FilterColorful
          SVGName="stall"
          text="در انتظار"
          className="w-24"
          color={activeFilters[1] ? "yellow" : "gray"}
          activeFilter={activeFilters}
          setActiveFilter={setActiveFilter}
          filterIndex={1}
        />

        <FilterColorful
          SVGName="failed"
          text="رد شده"
          className="w-24"
          color={activeFilters[2] ? "red" : "gray"}
          activeFilter={activeFilters}
          setActiveFilter={setActiveFilter}
          filterIndex={2}
        />
      </div>

      {/* TABLE */}
      <Table
        columns={[
          { key: "uuid", label: "کد تراکنش" },
          {
            key: "transactionType",
            label: "نوع تراکنش",
            render: (value) =>
              value === "deposit" ? (
                <Custom
                  text="واریز"
                  className="text-zi-text-light dark:text-zi-text-dark"
                  svg_name="deposit"
                />
              ) : value === "withdraw" ? (
                <Custom
                  text="برداشت"
                  className="text-zi-text-light dark:text-zi-text-dark"
                  svg_name="withdraw"
                  svgClassName="stroke-[#D71F1F]"
                />
              ) : (
                ""
              ),
          },
          { key: "paymentType", label: "روش پرداخت" },
          { key: "requestDate", label: "تاریخ درخواست" },
          { key: "volume", label: "مبلغ" },
          { key: "accountID", label: "کد حساب" },
          { key: "doneDate", label: "تاریخ تکمیل" },
          {
            key: "status",
            label: "وضعیت",
            render: (value) =>
              value === "done" ? (
                <StatusColorful
                  SVGName="tick"
                  text="تکمیل شده"
                  className="w-24"
                  color="green"
                />
              ) : value === "stall" ? (
                <StatusColorful
                  SVGName="stall"
                  text="در انتظار"
                  className="w-24"
                  color="yellow"
                />
              ) : value === "failed" ? (
                <StatusColorful
                  SVGName="failed"
                  text="رد شده"
                  className="w-24"
                  color="red"
                />
              ) : (
                ""
              ),
          },
        ]}
        data={filteredData}
      />
      {accLoading && (
        <div className="w-full flex justify-center items-center gap-2">
          <p className="text-[#808080]">در حال بارگذاری</p>
          <TableLoading className="text-[#808080]" />
        </div>
      )}
      {historyData && historyData.length === 0 && (
        <div className="w-full flex justify-center items-center flex-col gap-5">
          <p className="text-zi-text-light dark:text-zi-text-dark">
            موردی برای نمایش وجود ندارد
          </p>
          <SVG name="noData" classname="w-24 fill-cyan-500" />
        </div>
      )}
    </div>
  );
}
